import { render } from "./message-text.vue?vue&type=template&id=38e7ca88&scoped=true&ts=true"
import script from "./message-text.vue?vue&type=script&lang=ts"
export * from "./message-text.vue?vue&type=script&lang=ts"

import "./message-text.vue?vue&type=style&index=0&id=38e7ca88&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e7ca88"]])

export default __exports__